'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1002.934 817.876l-460.552-394.76c21.448-40.298 33.618-86.282 33.618-135.116 0-159.058-128.942-288-288-288-29.094 0-57.172 4.332-83.646 12.354l166.39 166.39c24.89 24.89 24.89 65.62 0 90.51l-101.49 101.49c-24.89 24.89-65.62 24.89-90.51 0l-166.39-166.39c-8.022 26.474-12.354 54.552-12.354 83.646 0 159.058 128.942 288 288 288 48.834 0 94.818-12.17 135.116-33.62l394.76 460.552c22.908 26.724 62.016 28.226 86.904 3.338l101.492-101.492c24.888-24.888 23.386-63.994-3.338-86.902z' })
    ));
};